export const selectVisible = (state) => state.filterShutdownStore.visible;
export const selectFilterChanged = (state) =>
  state.filterShutdownStore.filterChanged;
export const selectChosenFilterId = (state) =>
  state.filterShutdownStore.chosenFilterId;
export const selectChosenFilterName = (state) =>
  state.filterShutdownStore.chosenFilterName;
export const selectSearchValueShutdownsFilter = (state) =>
  state.filterShutdownStore.searchValue;
export const selectShutdownsFilter = (state) => state.filterShutdownStore;
export const selectNewShutdown = (state) =>
  state.filterShutdownStore.newShutdown;
